// All user-facing Spanish copy lives here, exactly as supplied for the Repsol
// flow. Fix wording in this file only; components just render it.

const copy = {
  back: "Atrás",
  next: "Siguiente",
  continue: "Continuar",

  // Step 1: cards
  energy: {
    field: "energy_type",
    title: "Descubre si puedes acceder a la tarifa especial de luz",
    subtitle:
      "Esta tarifa comercializada por Repsol ofrece luz y gas a un precio reducido",
    lead: "Comprueba tu elegibilidad en pocos segundos:",
    question: "¿Qué tipo de energía consumes?",
    options: ["Luz", "Gas", "Luz + Gas"],
  },

  // Plain option steps. `layout`: "stack" = one column, "grid" = two columns.
  choices: {
    housing: {
      field: "house_type",
      title: "¿Qué tipo de vivienda es?",
      layout: "stack",
      options: ["Piso", "Adosado/Unifamiliar", "Chalet independiente"],
    },
    knowsKwh: {
      field: "consumption_knowledge",
      title: "¿Sabes cuántos kWh de electricidad consumes al año?",
      subtitle:
        'Puedes calcularlo sumando los consumos anuales que verás en tu factura. Si no lo sabes, o no tienes la factura a mano, marca "No".',
      layout: "grid",
      options: ["Si", "No"],
    },
    kwh: {
      field: "yearly_kwh_range",
      title: "¿Cuántos kWh consumes al año aproximadamente?",
      layout: "grid",
      options: [
        "Menos de 3.000 kWh/año",
        "Entre 3.000-5.000 kWh/año",
        "Más de 5.000 kWh/año",
        "No lo sé",
      ],
    },
    power: {
      field: "contracted_power_range",
      title: "Ok ¿Y sabes la potencia contratada?",
      layout: "grid",
      options: ["Menos de 3 kw", "Entre 3 y 10 kw", "Más de 10 kw", "No lo se"],
    },
    sqm: {
      field: "sqm_range",
      title: "¿Cuántos metros cuadrados tiene tu casa aproximadamente?",
      layout: "stack",
      options: ["Menos de 100", "Entre 100 y 200", "Más de 200"],
    },
    people: {
      field: "people_at_home",
      title: "¿Y cuantas personas viven en casa?",
      layout: "grid",
      options: ["1", "2", "3", "Más de 3"],
    },
    bill: {
      field: "monthly_bill",
      title: "¿Cuánto pagas al mes por la luz?",
      layout: "grid",
      options: [
        "Menos de 50€",
        "Entre 50€ y 100€",
        "Entre 100€ y 200€",
        "Más de 200€",
      ],
    },
    provider: {
      field: "provider",
      title: "¿Cuál es tu proveedor de energía actual?",
      layout: "grid",
      options: ["Iberdrola", "Endesa", "Repsol", "Otra"],
    },
  },

  estimate: {
    title: "Ok sin problemas",
    text: "Hagamos una estimación rápida",
  },

  postal: {
    title: "¿Cuál es su código postal?",
    invalid: "Código postal inválido.",
  },

  // Shown when the current provider is Repsol (offer is for new customers only).
  ineligible: {
    title: "Lo sentimos, no eres elegible",
    text: "Esta tarifa esta solamente disponible para nuevos clientes, aquellos que ya son clienes de repsol no pueden acceder",
  },

  birth: {
    title: "¿Cual es tu año de nacimiento?",
    text: "Algunas tarifas solo están disponibles para ciertos rangos de edades",
  },

  goodNews: {
    title: "¡Buenas noticias!",
    text: "Según tu perfil, eres elegible para la Tarifa especial de Repsol.",
    note: "Ya casi estamos acabando...",
  },

  email: {
    title: "Antes de seguir, escribe tu email:",
    text: "Es necesario para recibir el estudio. Podrás eliminar luego tus datos con dos clics.",
    placeholder: "Email*",
    invalid: "Por favor, introduzca una dirección de correo electrónico válida",
  },

  phone: {
    leadBold: "Déjanos tu número de teléfono",
    lead: " para que un asesor de Repsol pueda llamarte.",
    label: "Teléfono*",
    note1: "Repsol te llamará una única vez. Si no respondes, perderás esta oferta.",
    note2: "Podrás eliminar tus datos en cualquier momento en 2 clics.",
    invalid:
      "Por favor, introduzca un número de teléfono español válido (9 dígitos)",
  },

  name: {
    title: "¿Cómo te llamas?",
    firstName: "Nombre*",
    lastName: "Apellido*",
  },

  consent: {
    title: "¡Perfecto! Un asesor de Repsol te llamará muy pronto.",
    text: "Mantente disponible y responde a la llamada: ahí te presentará la Tarifa y el importe de tu ahorro.",
    legalBefore: "Para finalizar, acepta la ",
    legalLink: "política de privacidad",
    legalAfter: ".",
    accept: "Acepto*",
    button: "Finalizar",
    // Not part of the supplied copy: system messages.
    duplicate: "Ya hemos recibido una solicitud con estos datos.",
    error: "No hemos podido enviar tus datos. Inténtalo de nuevo.",
  },

  thanks: {
    title: "¡RECIBIDO!",
    text: "Repsol te llamará muy pronto con tu Tarifa Personalizada.",
    warningBold: "Solo te llamarán una vez.",
    warning:
      "Si no respondes, no podrás recuperar esta oferta: esta Tarifa está disponible por tiempo limitado, y cada perfil solo tiene derecho a una única oportunidad.",
    strong: "Responde aunque sea un número que no conozcas.",
  },
};

export default copy;
